import Vue from 'vue'
import Router from 'vue-router'
import auth from '@/auth'
import LoginPage from '@/pages/LoginPage'
import ForgotPage from '@/pages/ForgotPage'
import PurchaseOrderNewPage from '@/pages/PurchaseOrder/PurchaseOrderNewPage'
import PurchaseOrderEditPage from '@/pages/PurchaseOrder/PurchaseOrderEditPage'
import PurchaseOrderReceivePage from '@/pages/PurchaseOrder/PurchaseOrderReceivePage'
import DashboardPage from '@/pages/Dashboard/DashboardPage'
import SearchPage from '@/pages/Search/SearchPage'
import ChangePassword from '@/pages/ChangePassword'
Vue.use(Router)


export default new Router({
    routes: [
        {
            path: '/login',
            name: 'LoginPage',
            component: LoginPage
        },
        {
            path: '/forgot-password',
            name: 'ForgotPage',
            component: ForgotPage
        },
        {
            path: '/logout',
            name: 'Logout',
            beforeEnter(to, from, next) {
                auth.logout();
                next('/login');
            }
        },
        {
            path: '/purchase-order/new',
            name: 'PurchaseOrderNewPage',
            component: PurchaseOrderNewPage,
            props: true,
            beforeEnter: requireAuth
        },
        {
            path: '/purchase-order/:id/edit',
            name: 'PurchaseOrderEditPage',
            component: PurchaseOrderEditPage,
            props: true,
            beforeEnter: requireAuth
        },
        {
            path: '/purchase-order/:id/receive',
            name: 'PurchaseOrderReceivePage',
            component: PurchaseOrderReceivePage,
            props: true,
            beforeEnter: requireAuth
        },
        {
            path: '/',
            name: 'DashboardPage',
            component: DashboardPage,
            props: true,
            beforeEnter: requireAuth
        },
        {
            path: '/search',
            name: 'SearchPage',
            component: SearchPage,
            props: true,
            beforeEnter: requireAuth
        },
        {
            path: '/change-password',
            name: 'ChangePassword',
            component: ChangePassword,
            props: true,
            beforeEnter: requireAuth
        }
    ]
})


function requireAuth(to, from, next) {
    if (!auth.loggedIn()) {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        })
    } else {
        next()
    }
}



// WEBPACK FOOTER //
// ./src/router/index.js